export default size => (dispatch) => {
  dispatch({ type: "APP/HTML/RESIZE", payload: size });
};
